var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlined-Bold/SignOut"
  }, /*#__PURE__*/React.createElement("path", {
    id: "IconVector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18C12 13.0294 16.0294 9 21 9H39C40.6569 9 42 10.3431 42 12C42 13.6569 40.6569 15 39 15H21C19.3431 15 18 16.3431 18 18V54C18 55.6569 19.3431 57 21 57H39C40.6569 57 42 58.3431 42 60C42 61.6569 40.6569 63 39 63H21C16.0294 63 12 58.9706 12 54V18ZM46.2 21.6C47.5255 20.6059 49.4059 20.8745 50.4 22.2L59.4 34.2C60.2 35.2667 60.2 36.7333 59.4 37.8L50.4 49.8C49.4059 51.1255 47.5255 51.3941 46.2 50.4C44.8745 49.4059 44.6059 47.5255 45.6 46.2L51 39H27C25.3431 39 24 37.6569 24 36C24 34.3431 25.3431 33 27 33H51L45.6 25.8C44.6059 24.4745 44.8745 22.5941 46.2 21.6Z",
    fill: "var(--error-500)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.1985e13a61a5ff7fcb53a2475e5d54a8.svg";
export { ForwardRef as ReactComponent };